import React from 'react'
import { Dropdown } from 'antd'
import chevronDownIcon from 'assets/images/chevron-down-24.svg'
import checkMarkSVG from 'assets/images/check-mark-16.svg'

import classNames from 'classnames'
import { useState, ReactElement } from 'react'

import styles from './style.module.scss'

interface SimpleColorButtonProps {
  color: string
  onChange: (color: string) => void
  appendColor?: string | null
}

const SimpleColorButton = ({ color, onChange, appendColor = null }: SimpleColorButtonProps) => {
  const [open, setOpen] = useState<boolean>(false)

  const contentRender = (): ReactElement => {
    const colorItems = [
      '#F83A22',
      '#D06B64',
      '#FA573C',
      '#FAD165',
      '#92E1C0',
      '#16A765',
      '#9FE1E7',
      '#4986E7',
      '#9A9CFF',
      '#CD74E6',
      '#C2C2C2',
    ]
    if (appendColor && !colorItems.includes(appendColor)) {
      colorItems.push(appendColor)
    }
    return (
      <div className={styles.simpleColorButtonMenus}>
        {colorItems.map((colorOption) => (
          <div
            className={styles.colorItem}
            key={colorOption}
            onClick={() => {
              onChange(colorOption)
              setOpen(false)
            }}
          >
            <div className={styles.colorDot} style={{ backgroundColor: colorOption }} />
            {colorOption === color && (
              <img src={checkMarkSVG} alt="check" className={styles.checkIcon} />
            )}
          </div>
        ))}
      </div>
    )
  }

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      trigger={['click']}
      placement="bottom"
      destroyOnHidden={true}
      overlayClassName={classNames('contextMenu')}
      popupRender={contentRender}
    >
      <div
        className={classNames(styles.simpleColorButton, 'simpleColorButton')}
        onClick={() => setOpen(!open)}
      >
        <div className={styles.colorButtonContent}>
          <div className={styles.colorDot} style={{ backgroundColor: color }} />
        </div>
        <img src={chevronDownIcon} alt="More" className={styles.chevronIcon} />
      </div>
    </Dropdown>
  )
}

export default SimpleColorButton
